<template>
  <layout-main-inner title="供应链统计">
    <scm-data />
    <scm-time-data />
  </layout-main-inner>
</template>

<script>
import ScmData from '../home/scm-data.vue'
import ScmTimeData from '../home/scm-time-data.vue'
export default {
  name: 'StatTrain',
  components: {
    ScmData, ScmTimeData
  }
}
</script>

<style>

</style>
